export interface Role {
  id: string | number;
  roleName: string;
  description: string;
  users: number;
  name: string;
  processes: string | number;
  products: string | number;
  createdBy: string;
  createdDate: string | null;
  lastModifiedBy: string | null;
  lastModifiedDate: string | null;
}

export enum PermissionActions {
  Create = 'CREATE',
  Delete = 'DELETE',
  Read = 'READ',
  Update = 'UPDATE',
}

export enum RoleType {
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
  END_USER = 'END_USER',
}

export enum PermissionModules {
  Organizations = 'Organizations',
  Users = 'Users',
  Products = 'Products',
  DataTables = 'Data Tables',
  DataSources = 'Data Sources',
  Integrations = 'Integrations',
  Forms = 'Forms',
  LandingPages = 'Landing Pages',
  SiteManagement = 'Site Management',
  ProcessMaps = 'Process Maps',
  RoleManagement = 'Role Management',
  FormsDataCapture = 'Forms Data Capture',
  RegistryManagement = 'Registry Management',
  FlatFileUpload = 'Flat-File Upload',
  BlockchainLogging = 'Blockchain Logging',
  ReportingAndAnalytics = 'Reporting & Analytics',
  Billing = 'Billing',
  Subscriptions = 'Subscriptions',
}

export interface PermissionDetail {
  id: string;
  module: PermissionModules;
  action: PermissionActions;
  createdAt: Date;
  updatedAt: Date;
}

export interface AssignedPermission {
  id: string;
  granted: boolean;
  createdAt: Date;
  updatedAt: Date;
  permission: PermissionDetail;
}

interface UserRole {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  user: {
    id: string;
    email: string;
    walletId: string;
    firstName: string;
    lastName: string;
    createdAt: Date;
    updatedAt: Date;
  };
}

interface RoleItem {
  id: string;
  name: string;
}

interface Product {
  commodity: RoleItem | null;
  variety: RoleItem | null;
  product: RoleItem | null;
  finalProduct: RoleItem | null;
  hasAllproducts: boolean;
}

export interface RoleDetail {
  id: string;
  name: string;
  description: string;
  type: string;
  createdAt: Date;
  updatedAt: Date;
  permissions: AssignedPermission[];
  userCompanyRoles: UserRole[];
  products: Product[];
  processes: RoleItem[];
  users: RoleItem[];
}

export interface UserPermissionsPerCompanyResponse {
  [key: string]: PermissionActions[];
}

export interface AssignableRolesResponse {
  id: string;
  name: string;
}
